module.exports = __webpack_public_path__ + "static/media/space-success.d07c93aa.svg";